/** Single source of truth for proposal wizard currency options and display symbols. */

export const CURRENCY_OPTIONS = [
  { value: 'NGN', label: 'Nigeria — Nigerian Naira (₦)' },
  { value: 'USD', label: 'United States — US Dollar ($)' },
  { value: 'GBP', label: 'United Kingdom — British Pound (£)' },
  { value: 'EUR', label: 'European Union — Euro (€)' },
  { value: 'GHS', label: 'Ghana — Ghanaian Cedi (₵)' },
  { value: 'KES', label: 'Kenya — Kenyan Shilling (KSh)' },
  { value: 'ZAR', label: 'South Africa — South African Rand (R)' },
  { value: 'CAD', label: 'Canada — Canadian Dollar (C$)' },
  { value: 'AUD', label: 'Australia — Australian Dollar (A$)' },
  { value: 'AED', label: 'United Arab Emirates — UAE Dirham (Dh)' },
  { value: 'UGX', label: 'Uganda — Ugandan Shilling (USh)' },
  { value: 'TZS', label: 'Tanzania — Tanzanian Shilling (TSh)' },
  { value: 'RWF', label: 'Rwanda — Rwandan Franc (FRw)' },
  { value: 'ZMW', label: 'Zambia — Zambian Kwacha (ZK)' },
  { value: 'XOF', label: 'West Africa — CFA Franc (CFA)' },
  { value: 'INR', label: 'India — Indian Rupee (₹)' },
];

/** Short symbols/prefixes — rendered adjacent to figures with no space (R850,000). */
export const CURRENCY_SYMBOLS = {
  NGN: '₦',
  USD: '$',
  GBP: '£',
  EUR: '€',
  GHS: '₵',
  KES: 'KSh',
  ZAR: 'R',
  CAD: 'C$',
  AUD: 'A$',
  AED: 'Dh',
  UGX: 'USh',
  TZS: 'TSh',
  RWF: 'FRw',
  ZMW: 'ZK',
  XOF: 'CFA',
  INR: '₹',
};

/** Legacy Business Plan wizard stored symbols instead of ISO codes. */
const LEGACY_SYMBOL_TO_CODE = {
  '₦': 'NGN',
  $: 'USD',
  '£': 'GBP',
  '€': 'EUR',
  R: 'ZAR',
  '₵': 'GHS',
  '₹': 'INR',
};

const KNOWN_CODES = new Set(CURRENCY_OPTIONS.map((o) => o.value));

/** Normalize wizard currency field to an ISO code (default NGN). */
export function normalizeCurrencyCode(value) {
  if (!value) return 'NGN';
  const raw = String(value).trim();
  if (LEGACY_SYMBOL_TO_CODE[raw]) return LEGACY_SYMBOL_TO_CODE[raw];
  const upper = raw.toUpperCase();
  if (KNOWN_CODES.has(upper)) return upper;
  return upper;
}

/** Prefix for amounts — symbol adjacent to the figure, no space. */
export function getCurrencyDisplayPrefix(code) {
  const normalized = normalizeCurrencyCode(code);
  const sym = CURRENCY_SYMBOLS[normalized];
  if (!sym) return normalized;
  return sym;
}

export function getCurrencyLabel(code) {
  const normalized = normalizeCurrencyCode(code);
  return CURRENCY_OPTIONS.find((o) => o.value === normalized)?.label || normalized;
}

export function formatWithCurrency(amount, code) {
  const prefix = getCurrencyDisplayPrefix(code);
  return `${prefix}${amount}`;
}
